'use strict';

require('./dist/tel.min.js');
require('./dist/metadatalite.js');
